export const removeProductAvailability = (): void => {
    const container = document.querySelector('.order-container');
    const existingAvailabilityContainer = container.querySelector('.product-availability');
    if (existingAvailabilityContainer) {
        existingAvailabilityContainer.remove();
    }
}
